import { KpiStatusRow, StatusType, StatusTypeValue } from './kpi-status-constants';

export const getStatusType = (row: KpiStatusRow): StatusTypeValue => {
  if (row.available) return StatusType.AVAILABLE;
  if (row.failed) return StatusType.UNAVAILABLE_FAILED;
  if (row.alert_only) return StatusType.UNAVAILABLE_ALERT_ONLY;
  return StatusType.UNAVAILABLE_CHECKING;
};
